import { types } from 'mobx-state-tree'

const EhealthUserLoginCommand = types.model('EhealthUserLoginCommand', {
  login: types.string,
  password: types.string,
})

export default EhealthUserLoginCommand
